var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostTotalTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64222 2.99085C7.1334 1.65743 4.85878 1.65743 3.34997 2.99085L5.99609 5.63698L8.64222 2.99085Z",
    fill: "#F5827F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00133 8.64222C10.3348 7.1334 10.3348 4.85878 9.00134 3.34997L6.35521 5.99609L9.00133 8.64222Z",
    fill: "#F7E380"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34997 9.00133C4.85878 10.3348 7.1334 10.3348 8.64222 9.00134L5.99609 6.35521L3.34997 9.00133Z",
    fill: "#97D9BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99085 3.34997C1.65743 4.85878 1.65743 7.1334 2.99085 8.64222L5.63698 5.99609L2.99085 3.34997Z",
    fill: "#A3DADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostTotalTable);
export default __webpack_public_path__ + "static/media/cost_total_table.27835ae772435493409d5a39ada9df7c.svg";
export { ForwardRef as ReactComponent };